import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';

@Component({
    selector: 'app-404',
    templateUrl: './notfound.html',
    styleUrls: ['./notfound.less'],
    standalone: false
})
export class NotFound implements OnInit {

  constructor(private router: Router) {

  }

  ngOnInit() {
    
  }

  go(){
    this.router.navigate(['home']);
  }

}
